import {Button, Checkbox, FormControlLabel, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";

export default function Step03(props) {
	
	const [valid,setValid] = useState(false);
	
	function isEmail(val) {
		let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regEmail.test(val);
	}
	
	useEffect(() => {
		window.analytics.track("Signup Stage", {
			stage: 3,
			"Stage name": "Contact details & declaration"
		});
	}, []);
	
	useEffect(() => {
		setValid(
			isEmail(props.state.frmContactEmail) &&
			(props.state.frmContactEmail === props.state.frmContactEmailConfirm) &&
			props.state.frmAcceptedDeclarationName !== '' &&
			props.state.frmContactEmail !== '' &&
			props.state.frmAcceptedDeclaration > 0
		)
	})
	
	function accept() {
		props.setState({
			...props.state,
			frmAcceptedDeclarationDate:new Date(),
			frmAcceptedDeclaration:1
		})
	}
	
	return (
		<div>
			<div className={"form-box"}>
				<p>
					Please read and accept the privacy declaration.
				</p>
				
				<h4>By submitting this information, you declare that:</h4>
				<ul>
					<li>-	The information provided is true and correct to the best of your knowledge</li>
					<li>-	You have the authority to complete this form on behalf of your veterinary clinic</li>
					<li>-	All methods of surgery at your clinic, including pain control, are up to date with current recommendations from the New Zealand Veterinary Association (NZVA)</li>
				</ul>
				
				<h4>Privacy Agreement</h4>
				<p>All personal information collected by SPCA for the purpose of the SPCA Desexing programme (“the programme”) is collected for the purpose of facilitating the booking of the relevant desexing appointments. By agreeing to take part in the programme, you agree to use any personal information accessed through the programme solely for that purpose and to abide by the requirements of the Privacy Act 2020 in relation to that personal information.</p>
				
				<div>
					<p>Your full name*</p>
					<TextField value={props.state.frmAcceptedDeclarationName} focused
					           onChange={(e) => props.setState({...props.state, frmAcceptedDeclarationName: e.target.value})}
					           error={ props.state.frmAcceptedDeclarationName === ''}
					           placeholder={"Your full name"}
					/>
				</div>
				
				<div>
					<p>Your position</p>
					<TextField value={props.state.frmAcceptedDeclarationPosition} focused
					           onChange={(e) => props.setState({...props.state, frmAcceptedDeclarationPosition: e.target.value})}
					           placeholder={"Your position"}
					/>
				</div>
				
				<div>
					<p>Contact email*</p>
					<TextField value={props.state.frmContactEmail} focused
					           onChange={(e) => props.setState({...props.state, frmContactEmail: e.target.value})}
					           error={!isEmail(props.state.frmContactEmail) || props.state.frmContactEmail === ''}
					/>
				</div>
				
				<div>
					<p>Confirm your contact email*</p>
					<TextField value={props.state.frmContactEmailConfirm} focused
					           onChange={(e) => props.setState({...props.state, frmContactEmailConfirm: e.target.value})}
					           error={ props.state.frmContactEmail === '' || props.state.frmContactEmailConfirm !== props.state.frmContactEmail}
					/>
				</div>
				
				<hr style={{width:'100%', margin:'20px 0'}} />
				
				<div>
					<FormControlLabel
						control={<Checkbox value={(props.state.frmAcceptedDeclaration === 1)} onChange={accept}/>}
						label="I acknowledge and accept*"/>
				</div>
				
				<div>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={"contained"}
					        onClick={() => props.setStep(props.step + 1)}
					        disabled={!valid}
					>
						Next
					</Button>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={""}
					        onClick={() => props.setStep(props.step - 1)}>
						Back
					</Button>
				</div>
				
			</div>
		</div>
	)
}
